<span class="color-black-warm-600 text-c2-m-300 text-md-c1-l-300">
  нажимая кнопку "отправить заявку", вы даёте согласие на обработку
  <a class="color-black-warm-600 link-underlined" [routerLink]="'/personal_data'">персональных данных</a>
</span>
